<!-- 
    通用定位组件(参数type:资源类型（资源类型就是在五个一控制台配置图层时选择的类型）,objid:资源的对象ID)
    mode:模式:web/h5，在显示上有所区别，例如h5里面不显示zoom控件
-->
<template>
  <div class="dhmapWrapperNew" id="dhmap-wrapper">
    <div id="locatemap" ref="locatemap"></div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from "vuex";
import "ol/ol.css";
import {
  initMap,
  addLayerToMap,
  addLocateLayerToMap,
  actLocate,
  mapalert,
} from "@/utils/MapUtils";

export default {
  name: "map-locator",
  components: {},
  props: {
    param: {
      type: Object,
      default: () => {
        return {};
      },
    },
    mode: { type: String, default: "web" },
  },
  data() {
    return {
      map: null,
      gisconfig: {},
    };
  },
  mounted() {
    this.$nextTick(() => {
      if (this.param && this.param.zrqlx && this.userinfo.appId) {
        this.loadMap();
      }
    });
  },
  methods: {
    loadMap() {
      var _this = this;

      this.$api.Mapapi.getconfig({
        appId: _this.userinfo.appId,
      })
        .then((res) => {
          if (res.code == "1" && res.data) {
            _this.clearDiv();
            _this.gisconfig = res.data;
            //设置该地图根据CQL进行过滤加载
            _this.gisconfig.queryWithCQL = true;
            //设置CQL进行查询，必须要提供uid、uregion、uregionlevel三个参数
            _this.gisconfig.uid = "";
            _this.gisconfig.uregion = _this.param.zqCode;
            _this.gisconfig.uregionlevel = [
              null,
              1,
              1,
              2,
              2,
              3,
              3,
              4,
              4,
              4,
              5,
              5,
              5,
              5,
              5,
            ][_this.gisconfig.uregion.length];
            //初始化地图

            _this.map = initMap("locatemap", _this.gisconfig, {
              showZoom: false,
            });

            _this.map.gisConfig = res.data;
            //添加图层
            addLayerToMap(_this.map, _this.gisconfig, null, [
              "geo_sheng",
              "geo_shi",
              "geo_xian",
              "geo_xiang",
              "geo_cun",
            ]);
            addLocateLayerToMap(_this.map);
            //调用MapUtil添加图层
            actLocate(_this.map, _this.param.zrqlx, _this.param.zrqobjid);
          } else {
            mapalert(res.msg);
          }
        })
        .catch((err) => {
          
          mapalert("定位类型不存在!");
        });
    },
    clearDiv() {
      //找出地图上所有的覆盖DIV
      let box = document.getElementById("locatemap");
      box.parentNode.removeChild(box);
      let pDiv = document.getElementById("dhmap-wrapper");
      let oDiv = document.createElement("div");
      oDiv.id = "locatemap";
      oDiv.ref = "locatemap";
      pDiv.appendChild(oDiv);
    },
    resize() {
      var _this = this;
      setTimeout(function () {
        _this.map.updateSize();
      }, 200);
    },
  },
  computed: {
    ...mapState(["userinfo"]),
  },
  watch: {
    param: {
      handler: function () {
        let _this = this;
        if (_this.param.zrqlx && _this.param.zrqobjid && _this.userinfo.appId) {
          _this.loadMap();
        }
      },
      deep: true,
    },
  },
  directives: {
    // 使用局部注册指令的方式
    resize: {
      // 指令的名称
      bind(el, binding) {
        // el为绑定的元素，binding为绑定给指令的对象
        let width = "",
          height = "";
        function isReize() {
          const style = document.defaultView.getComputedStyle(el);
          if (width !== style.width || height !== style.height) {
            binding.value(); // 关键
          }
          width = style.width;
          height = style.height;
        }
        el.__vueSetInterval__ = setInterval(isReize, 300);
      },
      unbind(el) {
        clearInterval(el.__vueSetInterval__);
      },
    },
  },
};
</script>

<style lang="less">
.dhmapWrapperNew {
  width: 100%;
  height: 100%;
  > div {
    width: 100%;
    height: 100%;
  }
}
/* #locatemap {
  width: 100%;
  height: 100%;
} */
</style>